import React from "react";

import { InputBaseComponentProps } from "@material-ui/core/InputBase";
import { fade, useTheme } from "@material-ui/core/styles";

export const StripeInput: React.FC<InputBaseComponentProps> = props => {
	const {
		component: Component,
		inputRef,
		"aria-invalid": ariaInvalid,
		"aria-describedby": ariaDescribeBy,
		disabled,
		defaultValue,
		required,
		onKeyDown,
		onKeyUp,
		readOnly,
		autoComplete,
		autoFocus,
		type,
		name,
		rows,
		options,
		...other
	} = props;
	const theme = useTheme();
	const [mountNode, setMountNode] = React.useState<typeof Component | null>(null);

	React.useImperativeHandle(
		inputRef,
		() => ({
			focus: () => mountNode.focus()
		}),
		[mountNode]
	);

	return (
		<Component
			onReady={setMountNode}
			options={{
				...options,
				disabled,
				style: {
					base: {
						backgroundColor: "#f2f2f2",
						color: theme.palette.text.primary,
						fontSize: `${theme.typography.fontSize}px`,
						fontFamily: theme.typography.fontFamily,
						"::placeholder": {
							color: fade(theme.palette.text.primary, 0.42)
						}
					},
					invalid: {
						color: theme.palette.text.primary
					}
				}
			}}
			{...other}
		/>
	);
};
